<template>
  <v-btn :class="btnClasses" 
    :color="color" 
    :outlined="outlined" 
    :disabled="disabled" 
    :small="normalizedSize === 'small'" 
    :x-small="normalizedSize === 'x-small'" 
    :large="normalizedSize === 'large'" 
    :medium="normalizedSize === 'medium'" 
    :x-large="normalizedSize === 'x-large'" 
    :block="block" @click="$emit('click')">
    <!-- Left icon -->
    <v-icon v-if="leftIcon" left class="mr-2">
      {{ leftIcon }}
    </v-icon>
    <!-- Button Text -->
    <span>{{ text }}</span>
    <!-- Right icon -->
    <v-icon v-if="rightIcon" right class="ml-2">
      {{ rightIcon }}
    </v-icon>
  </v-btn>
</template>
<script>
  export default {
    name: "AppButton",
    props: {
      text: {
        type: String,
        default: "Button"
      },
      color: {
        type: String,
        default: "primary"
      },
      /** choose size OR let it auto-resize */
      size: {
        type: String,
        default: "medium", // Accepts shorthand or full names
        // Added 'md' alias for medium
        validator: v => ["sm", "xs", "md", "lg", "xl", "x-small", "small", "medium", "large", "x-large"].includes(v)
      },
      outlined: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      leftIcon: {
        type: String,
        default: null
      },
      rightIcon: {
        type: String,
        default: null
      },
      block: {
        type: Boolean,
        default: false
      },
      /** new prop: responsive automatically picks size from breakpoints */
      responsive: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      btnClasses() {
        return {
          "pa-2": true,
          "btn--responsive": this.responsive,
        };
      },
      // Normalize size to Vuetify's full names for internal use
      normalizedSize() {
        // If responsive, use breakpoint mapping
        let size = this.size;
        if (this.responsive) {
          const bp = this.$vuetify.breakpoint.name; // xs sm md lg xl
          switch (bp) {
            case "xs":
              size = "x-small";
              break;
            case "sm":
              size = "small";
              break;
            case "md":
              size = "medium";
              break;
            case "lg":
              size = "large";
              break;
            case "xl":
              size = "x-large";
              break;
            default:
              size = "medium";
          }
        }
        // Map shorthands to full names
        const map = {
          sm: "small",
          xs: "x-small",
          md: "medium",
          lg: "large",
          xl: "x-large"
        };
        return map[size] || size;
      },
    },
  };
</script>